export default __webpack_public_path__ + "static/media/Mark-6-HUD-Altimeter.18b3f0a0.jpg";